import { useFormContext } from '../../FormContext';
export function useDataSourceProps(element, value) {
    const { getDataSourceProps } = useFormContext();
    return (getDataSourceProps === null || getDataSourceProps === void 0 ? void 0 : getDataSourceProps(element, value)) || {};
}
//# sourceMappingURL=useDataSourceProps.js.map